import {
  Div,
  lightTheme,
  formatNumber,
  H3,
  H5,
  P,
  Separator,
  VerticalSeparator,
  Icon,
  LogoWhiteCircle,
  AgentCustomerStatsResponse,
  Box,
} from '@vgrubs/components';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { dataCustomers } from '../Dashboard/dummyData';

const VGrubsEcosystemStats = ({
  stats,
}: {
  stats: AgentCustomerStatsResponse;
}) => (
  <Box $p="16px" style={{ flex: 1 }}>
    <Div $flex $alignCenter $gap="8px" $between $p="0 0 16px 0">
      <Div $flex $alignCenter $gap="8px">
        <H3 $m="0">vGrubs Ecosystem</H3>
      </Div>
    </Div>

    <Div $flex $alignCenter $gap="24px" $gapSM="0" $column>
      <Div $widthSM="100%" $flex $justifyCenter>
        {stats?.customersOverview && (
          <Div
            $relative
            $heightSM="200px"
            $height="250px"
            $width="250px"
            $mSM="20px 0"
          >
            <Icon
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              $size={window.innerWidth < 800 ? 60 : 100}
            >
              <LogoWhiteCircle />
            </Icon>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={dataCustomers(stats?.customersOverview)}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  // label={renderCustomizedLabel}
                  innerRadius={window.innerWidth < 800 ? 30 : 50}
                  fill="#000000"
                  dataKey="value"
                >
                  {dataCustomers(stats?.customersOverview).map(
                    (entry, index) => (
                      <Cell key={`cell-${index}`} fill={entry.color} />
                    )
                  )}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </Div>
        )}
      </Div>

      <Div $width="100%" $widthSM="100%">
        <Div $flex $alignCenter $between>
          <P $m="0" $bold>
            New Customers
          </P>
          <Div $flex $alignCenter $columnSM $alignEndSM>
            <H3 $color={lightTheme.blue} $m="0">
              {formatNumber(stats?.customersOverview.newCustomers || 0)}
            </H3>
            <Div $desktop>
              <VerticalSeparator
                $w="2px"
                $color={lightTheme.blue}
                $h="20px"
                $m="10px"
              />
            </Div>
            <Div $mobile>
              <Separator
                $w="20px"
                $color={lightTheme.blue}
                // $h="2px"
                $m="5px 0"
              />
            </Div>
            <H5 $color={lightTheme.blue} $m="0">
              {formatNumber(
                stats?.customersOverview.newCustomersPercentage || 0
              )}
              %
            </H5>
          </Div>
        </Div>

        <Separator $m="10px 0" />

        <Div $flex $alignCenter $between>
          <P $m="0" $bold>
            Returning Customers
          </P>
          <Div $flex $alignCenter $columnSM $alignEndSM>
            <H3 $color={lightTheme.green} $m="0">
              {formatNumber(stats?.customersOverview.returningCustomers || 0)}
            </H3>
            <Div $desktop>
              <VerticalSeparator
                $w="2px"
                $color={lightTheme.green}
                $h="20px"
                $m="10px"
              />
            </Div>
            <Div $mobile>
              <Separator
                $w="20px"
                $color={lightTheme.green}
                // $h="2px"
                $m="5px 0"
              />
            </Div>
            <H5 $color={lightTheme.green} $m="0">
              {stats?.customersOverview.returningCustomersPercentage}%
            </H5>
          </Div>
        </Div>

        <Separator $m="10px 0" />

        <Div $flex $alignCenter $between>
          <P $m="0" $bold>
            Total Customers
          </P>
          <Div $flex $alignCenter $columnSM $alignEndSM>
            <H3 $m="0">
              {formatNumber(stats?.customersOverview.totalCustomers || 0)}
            </H3>
          </Div>
        </Div>
      </Div>
    </Div>
  </Box>
);

export { VGrubsEcosystemStats };
